<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Document Verification <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i>
                Edit Verify Document Form</h1>
            <div class="content-wrap">
                <h3 class="form-hd2">Fill the form below to edit document.</h3>
                <h4><span class="color-red">Reason for Edit:-</span> {{editReason}}</h4>
                <form [formGroup]="editdocform">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="first_name" class="form-label">First Name</label>
                                <input #inputFile1 type="text"            
                                    disabled                         
                                    formControlName="firstname" 
                                    class="form-control form-input"                                   
                                    [(ngModel)]="editRequest.first_name"
                                    [ngClass]="{'is-invalid': submitted && f.firstname.errors }" />
                                    <div *ngIf="submitted && f.firstname.errors" class="invalid-feedback">
                                        <div *ngIf="f.firstname.errors.required">First Name is required</div>
                                    </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="lastName" class="form-label">Last Name</label>
                                <input type="text" 
                                    disabled
                                    formControlName="lastname" 
                                    class="form-control form-input"
                                    [(ngModel)]="editRequest.last_name"
                                    [ngClass]="{'is-invalid': submitted && f.lastname.errors }" />
                                    <div *ngIf="submitted && f.lastname.errors" class="invalid-feedback">
                                        <div *ngIf="f.lastname.errors.required">Last Name is required</div>
                                    </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="enNumber" class="form-label">Seat Number</label>
                                <input 
                                    type="text" 
                                    placeholder="Enter Seat No." 
                                    formControlName="enrollno" 
                                    [(ngModel)]="editRequest.enroll_no"
                                    class="form-control form-input"
                                    [ngClass]="{'is-invalid': submitted && f.enrollno.errors }" />
                                    <div *ngIf="submitted && f.enrollno.errors" class="invalid-feedback">
                                        <div *ngIf="f.enrollno.errors.required">Enrollment no. is required</div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="stream" class="form-label">Stream</label>
                                <select 
                                    formControlName="streamid" 
                                    class="form-control form-input"
                                    [(ngModel)]="editRequest.stream_id"
                                    [ngClass]="{'is-invalid': submitted && f.streamid.errors }"
                                    (change)='getBranAndStream($event.target.value)'>
                                    <option value="" disabled selected> Please select Stream </option>
                                    <option 
                                        *ngFor="let stream of streamDropDown" 
                                        [ngValue]="stream.id" 
                                        [selected]="streamid"
                                    >
                                        {{stream.streamName}}
                                    </option>
                                </select>
                                <div *ngIf="submitted && f.streamid.errors" class="invalid-feedback">
                                    <div *ngIf="f.streamid.errors.required">Stream is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="branch" class="form-label">Branch</label>
                                <select 
                                    formControlName="branchid" 
                                    class="form-control form-input"
                                    [(ngModel)]="editRequest.branch_id"
                                    [ngClass]="{'is-invalid': submitted && f.branchid.errors }"
                                    value="branchId">
                                    <option value="" selected> Please select Branch </option>
                                    <option 
                                        *ngFor="let branch of branchList" 
                                        [ngValue]="branch.id"
                                        [selected]="branch.id == branchId"
                                    >
                                        {{branch.branchName}}
                                    </option>
                                </select>
                                <div *ngIf="submitted && f.branchid.errors" class="invalid-feedback">
                                    <div *ngIf="f.branchid.errors.required">Branch is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="semester" class="form-label">Semester</label>
                                <select 
                                    formControlName="semid" 
                                    class="form-control form-input" 
                                    id="semid"
                                    [ngClass]="{'is-invalid': submitted && f.semid.errors }"
                                    [(ngModel)]="editRequest.semid"
                                    value="semId"
                                    >
                                    <option value="" selected> Please select Semester </option>
                                    <option 
                                        *ngFor="let semester of semesterList"
                                        [ngValue]="semester.id"
                                        [selected]="semester.id == semId"
                                    >
                                        {{semester.semester}}</option>
                                </select>
                                <div *ngIf="submitted && f.semid.errors" class="invalid-feedback">
                                    <div *ngIf="f.semid.errors.required">Semester is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="document" class="form-label">Document</label>
                                <select 
                                    formControlName="docname" 
                                    class="form-control form-input" 
                                    id="docname" 
                                    [ngClass]="{'is-invalid': submitted && f.docname.errors }"
                                    [(ngModel)]="editRequest.doc_id"
                                    >
                                    <option value="" disabled selected> Please select Document </option>
                                    <option 
                                        *ngFor="let document of documentDropDown" 
                                        [ngValue]="document.id"
                                        [selected]="editRequest.doc_id"
                                    >
                                        {{document.documentName}}</option>
                                </select>
                                <div *ngIf="submitted && f.docname.errors" class="invalid-feedback">
                                    <div *ngIf="f.docname.errors.required">Document is required</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="requesttype" class="form-label">Request Type</label>
                                <select 
                                    formControlName="requesttype" 
                                    class="form-control form-input"
                                    id="requesttype"
                                    [(ngModel)]="editRequest.request_type_id"
                                    [ngClass]="{'is-invalid': submitted && f.requesttype.errors }"
                                    >
                                    <option value="" disabled selected> Please select Request Type </option>
                                    <option 
                                        *ngFor="let request of RequestTypeDropDown" 
                                        [ngValue]="request.id"
                                        [selected]="requestTypeId"
                                        >
                                        {{request.requestType}}</option>
                                </select>
                                <div *ngIf="submitted && f.requesttype.errors" class="invalid-feedback">
                                    <div *ngIf="f.requesttype.errors.required">Request type is required</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="college" class="form-label">College Name</label>
                                <select 
                                    formControlName="collegenameid" 
                                    class="form-control form-input"
                                    id="collegenameid"
                                    [ngClass]="{'is-invalid': submitted && f.collegenameid.errors }"
                                    [(ngModel)]="editRequest.college_name_id"
                                    >
                                    <option value="" disabled selected> Please select College </option>
                                    <option 
                                        *ngFor="let college of collegeDropDown" 
                                        [ngValue]="college.id"
                                        [selected]="college.id == collegeNameVal"
                                    >
                                        {{college.collegeName}}</option>

                                </select>
                                <div *ngIf="submitted && f.collegenameid.errors" class="invalid-feedback">
                                    <div *ngIf="f.collegenameid.errors.required">College name is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="passingYear" class="form-label">Year of Passing</label>
                                <mat-form-field>
                                    <input matInput [matDatepicker]="dp" [formControl]="date" autocomplete="off"
                                        placeholder="Select Month and Year" formControlName="yearAndMonthSelect" [matDatepickerFilter]=dateFilter >
                                    <mat-datepicker-toggle matSuffix [for]="dp" ></mat-datepicker-toggle>
                                    <mat-datepicker #dp startView="multi-year" 
                                        (yearSelected)="chosenYearHandler($event)"
                                        (monthSelected)="chosenMonthHandler($event, dp)"
                                        panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>
                               
                                <!-- <div  class="invalid-feedback">
                                    <div >{{requiredYear}}</div>
                                </div> -->
                            </div>
                        </div>
                       
                            <!-- <div class="form-group input-group-lg">
                                <label for="alt_email" class="form-label">Alternate EmailID <span style="color:#21B4F3;font-size:100% ;"> Max 5 comma separated email ids allowed.</span></label>
                                <input type="text" required
                                      placeholder="Enter EmailId" 
                                    formControlName="alt_email"
                                    class="form-control form-input" 
                                    [(ngModel)]="editRequest.alt_email"
                                    (change)="inputChanged($event)"
                                    [ngClass]="{'is-invalid': submitted && f.alt_email.errors }" />
                                  
                                    <div *ngIf="submitted && f.alt_email.errors" class="invalid-feedback">
                                        <div *ngIf="f.alt_email.errors.required">Email ID cannot be empty.</div>
                                    </div>
                            </div> -->
                           <!--  <div class="form-group input-group-lg">
                                <label for="altemail" class="form-label">Alternate Email</label>
                                <input  
                                    type="text"                                          
                                    formControlName="altemail" 
                                    class="form-control form-input"    
                                    [(ngModel)]="editRequest.alt_email"   
                                    />
                                     <div *ngIf="submitted && f.altemail.errors" class="invalid-feedback">
                                        <div *ngIf="f.altemail.errors.required">Alternate email is required</div>
                                    </div> 
                            </div>-->
                       
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="uploadDocPath" class="form-label">Upload Document<span style="color:#f32f21;font-size:15px ;"> All semester marksheets should be uploaded in one PDF (upto 5 MB).</span></label>
                                <input 
                                    formControlName="uploaddocpath" 
                                    type="file"
                                    class="form-control form-input border-none"
                                    accept=".png,.jpg,.jpeg,.tiff,.pdf" 
                                    id="uploadDocPath" [(ngModel)]="editRequest.upload_doc_path"
                                    (change)="catchEvent($event.target.files)"
                                    >
                                    <button [disabled]="newFileCheck" (click)="viewDocument()" class="button bg-theme color-white">View Document</button>
                                    <!-- <div *ngIf="submitted && f.uploaddocpath.errors" class="invalid-feedback">
                                        <div *ngIf="f.uploaddocpath.errors.required">Upload document is required</div>
                                    </div> -->
                                <!-- <div class="invalid-feedback">
                                    <div>Upload Document is required</div>
                                </div> -->
                            </div>
                        </div>
                        <input placeholder="filepath" formControlName="filepath" hidden>

                        <div class="col-md-3" >
                        <div class="form-group input-group-lg">
                            <label for="alt_email" class="form-label">Alternate EmailID <span style="color:#21B4F3;font-size:100% ;"> Max 5 comma separated email ids allowed.</span></label>
                            <input  
                                type="text"                                          
                                formControlName="altemail" 
                                class="form-control form-input" (change)="inputChanged($event)" [ngClass]="{'is-invalid': submitted && f.altemail.errors }" 
                                [(ngModel)]="editRequest.alt_email"/>
                                <div *ngIf="altEmailLengthCheck">
                                    <div style="color:red;">Only upto 5 emails permitted.</div>
                                </div>
                                <div *ngIf="altEmailValidation">
                                    <div style="color:red;">Please enter correct email ids.</div>
                                </div>        
                        </div>
                    </div>

                    <!--<div class="col-md-3">
                        <div class="form-group input-group-lg">
                            <label for="altEmail" class="form-label">Alternate EmailID <span style="color:#21B4F3;font-size:100% ;"> Max 5 comma separated email ids allowed.</span></label>
                            <input placeholder="Enter EmailId" formControlName="altemail"
                                class="form-control form-input"  (change)="inputChanged($event,i)"
                                [ngClass]="{ 'is-invalid': submitted && fa.controls[i].controls.altEmail.invalid}"  [(ngModel)]="editRequest.alt_email">
                                <div *ngIf="altEmailLengthCheck">
                                    <div style="color:red;">Only upto 5 emails permitted.</div>
                                </div>
                                <div *ngIf="altEmailValidation">
                                    <div style="color:red;">Please enter correct email ids.</div>
                                </div>
                            <div *ngIf="submitted && fa.controls[i].controls.altEmail.invalid"
                                class="invalid-feedback">
                                 <div *ngIf="fa.controls[i].controls.altEmail.errors.pattern">Email must be a
                                    valid email address
                                </div> 
                            </div>
                        </div>
                    </div>-->

                    </div>

                    <div class="row">

                        <div class="col-md-3" >
                            <div class="form-group input-group-lg">
                                <label for="college" class="form-label">Verification Purpose</label>
                                <select formControlName="embassyid" class="form-control form-input"
                                
                                    id="embassyid" (change)="getembassylist($event.target.value)" [(ngModel)]="editRequest.embassyid">
                                    <option value="" disabled selected>Please select verification Purpose</option>
                                    <option *ngFor="let embassy of EmbassyDropDown" [ngValue]="embassy.id">
                                        {{ embassy.embassyName }}</option>

                                </select>
                            </div>
                        </div>

                        <div class="col-md-3">

                            
                            <div class="form-group input-group-lg">
                                <label for="embassyname" class="form-label">Embassy Name</label>
                                <input placeholder="embassy name"   [readonly]="embassyidDisabled"
                                    formControlName="embassyname"  [(ngModel)]="editRequest.embassyname" class="form-control form-input">
                            </div>
                          </div>
                          
                          <div class="col-md-3">
                            <div class="form-group input-group-lg">
                              <label for="embassyaddress" class="form-label">Embassy Address</label>
                              <input
                                placeholder="Embassy Address"
                                formControlName="embassyaddress" [readonly]="embassyidDisabled" [(ngModel)]="editRequest.embassyaddress"

                                class="form-control form-input"/>

                            </div>
                          </div>
                    </div>
                    <div *ngIf="fillSemBranch">
                        <p style="color: red;">Please select Branch and Semester to proceed.</p>
                    </div>
                    <div *ngIf="fillembassyname">
                        <p style="color: red;">Please select embassy name and embassy address.</p>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="onSubmit()">Save</button>
                </form>
            </div>
        </div>
    </div>
</div>


<ng-template #showModalBoxImage let-modal>
    <div class="modal-content">
        <div class="modal-header bg-theme">
            <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>

            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
      
        <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <!-- <button   (click)="showmagnify()">Magnify</button>   -->
                <!-- <div *ngIf="!isVrPdf && !noImage1">
                  <app-magnify  [imageId]="imgname" [ImageURL]="document_path"> </app-magnify>
                </div> -->
              
                <p class="doc-txt">To be verified</p>
                <div *ngIf="isVrPdf">
                  <div class="ng-star-inserted22">
                    <!-- <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer> -->
                    <div class="img-magnifier-container">
                      <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
                    </div>
                  </div>
                  <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
                </div>
                <div *ngIf="isVrImage">
                  <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy"> -->
                  <div class="img-magnifier-container">
                    <img src={{document_path}}  class="doc-img" id="uploadImg1"  (click)="showLightbox(0)" loading="lazy">
                  </div>
                </div>
              </div>
            </div>
          </div>

    </div>
</ng-template>


<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>

</ng-template>